var AddMembersModal;

import mixin from './mixin.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import ShuttleListItem from './shuttle_list_members_item.js';

export default AddMembersModal = Vue.extend({
  mixins: [mixin],
  components: {
    "shuttle-list-item": ShuttleListItem
  },
  props: {
    addMembersCallback: {
      type: Function,
      required: true
    }
  },
  data: function() {
    return {
      filterKeyword: '',
      selectedUsers: []
    };
  },
  template: `<modal title='添加组织成员' extendClass='organization-add-member-modal' size='large' ref="modal">
  <div class="modal-body">
    <div class="shuttle-container">
      <shuttle-container-candidates
        :organizationId="organization.id"
        :queryUrl="resourceUrl"
        @selectedOrganizationIdChanged="updateSelectedOrganizationIdFunc"
        @userSelected="userSelectedFunc"
        ref="shuttleContainerCandidates" />
      <div class="shuttle-box right">
        <div class="justify-box mb-2">
          <div class="content light-gray-text">已选成员</div>
        </div>

        <div class="input-control left-addon mb-4">
          <input v-model.trim='filterKeyword' class="controlled-input floated" placeholder="搜索成员名称或电话号码" type="text">
          <div class="addon">
            <i class="slp-search"></i>
          </div>
        </div>
        <div class="shuttle-list">
          <shuttle-list-item v-for="member in filterSelectedMembers"
                              :key="member.id"
                              :member="member"
                              @deleteSelectedMember="deleteSelectedMember(member)"/>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" slot="footer">
    <button class="outlined btn-default" @click='cancel'>取消</button>
    <button @click='addMembers' :disabled='requestDisabled'>确定</button>
  </div>
</modal>`,
  computed: {
    resourceUrl: function() {
      return `/admin/organizations/${this.selectedOrganizationId}/members/query`;
    },
    filterSelectedMembers: function() {
      if (_.isEmpty(this.filterKeyword)) {
        return this.selectedUsers;
      } else {
        return _.reduce(this.selectedUsers, (memo, member) => {
          var ref, ref1;
          if (((ref = member.name) != null ? ref.indexOf(this.filterKeyword) : void 0) > -1 || ((ref1 = member.phone) != null ? ref1.indexOf(this.filterKeyword) : void 0) > -1) {
            memo.push(member);
          }
          return memo;
        }, []);
      }
    },
    requestDisabled: function() {
      return !this.selectedUsers.length;
    }
  },
  methods: {
    addMembers: function() {
      return this.addMembersCallback(this.selectedUsers);
    },
    userSelectedFunc: function(user) {
      return this.selectedUsers.push(user);
    },
    deleteSelectedMember: function(member) {
      this.selectedUsers = _.reject(this.selectedUsers, function(su) {
        return su.id === member.id;
      });
      return this.$refs.shuttleContainerCandidates.deselectUser(member);
    }
  }
});
